import image0 from './img/0.jpg';
import image1 from './img/1.jpg';
import image2 from './img/2.jpg';
import image3 from './img/3.jpg';
import image4 from './img/4.jpg';
import image5 from './img/5.jpg';
import image6 from './img/6.jpg';
import image7 from './img/7.jpg';
import image8 from './img/8.jpg';
import image9 from './img/9.jpg';
import image10 from './img/10.jpg';
import image11 from './img/11.jpg';
import image12 from './img/12.jpg';

export const RestaurantsDataList = [
  {
    id: 0,
    img: image0,
    locations: [
      {
        branch: '田町店',
        address: '〒1080014 東京都港区芝5-9-8 GEMS田町2F',
        anycarryUrl: 'https://anycarry.jp/tenshinonenmyon-akumanobibinmyon/',
        uberUrl:
          'https://www.ubereats.com/jp/store/%E5%A4%A9%E4%BD%BF%E3%81%AE%E3%83%8D%E3%83%B3%E3%83%9F%E3%83%A7%E3%83%B3%E3%83%BB%E6%82%AA%E9%AD%94%E3%81%AE%E3%83%92%E3%83%92%E3%83%B3%E3%83%9F%E3%83%A7%E3%83%B3-%E7%94%B0%E7%94%BA%E5%BA%97/t7dPD3VmQeOkK-ADTHPnAA?diningMode=PICKUP',
      },
    ],
    name: '天使のネンミョン・悪魔のビビンミョン',
    phrase: 'プロ考案の本格冷麺＆ビビン麺！',
    description:
      '麻布界隈の人気焼肉店でシェフの経験をもつ店主がデリバリー向けに開発した冷麺とビビン麺！年中おいしく召し上がれます！ ',
  },
  {
    id: 1,
    img: image1,
    locations: [
      {
        branch: '田町店',
        address: '〒1080014 東京都港区芝5-9-8 GEMS田町2F',
        anycarryUrl: '',
        uberUrl:
          'https://www.ubereats.com/jp/store/%E6%98%8E%E3%82%8A%E3%81%AE%E7%81%AF%E3%82%8B%E6%A3%AE%E3%81%AE%E3%82%B7%E3%83%81%E3%83%A5%E3%83%BC%E5%B1%8B%E3%81%95%E3%82%93-%E7%94%B0%E7%94%BA%E5%BA%97/jemMt176WrGyVbnXcsaxzg?diningMode=PICKUP',
      },
    ],
    name: '明りの灯る森のシチュー屋さん',
    phrase: '森の中でひっそりと営業中',
    description:
      '自然の恵みがたっぷり入ったシチュー屋さん！軽食にもお食事にも！様々なシーンでご利用いただけます！',
  },
  {
    id: 2,
    img: image2,
    locations: [
      {
        branch: '田町店',
        address: '〒1080014 東京都港区芝5-9-8 GEMS田町2F',
        anycarryUrl:
          'https://anycarry.jp/kanjukugratin-netsuretsudoria-tamachi/',
        uberUrl:
          'https://www.ubereats.com/jp/store/%E5%AE%8C%E7%86%9F%E3%82%AF%E3%83%A9%E3%82%BF%E3%83%B3%E3%81%A8%E7%86%B1%E7%83%88%E3%83%88%E3%83%AA%E3%82%A2-%E7%94%B0%E7%94%BA%E5%BA%97/koDbSTaXX5emgQ8za0xc3g?diningMode=PICKUP&mod=storeDeliveryTime&modctx=%257B%2522entryPoint%2522%253A%2522store-auto-surface%2522%252C%2522encodedStoreUuid%2522%253A%2522koDbSTaXX5emgQ8za0xc3g%2522%257D&ps=1',
      },
    ],
    name: '完熟グラタンと熱烈ドリア',
    phrase: '注文が入ってから焼き上げる本格派！',
    description:
      '完全店内仕込み！グラタン＆ドリアのお店！豊富なメニューで子供から大人まで大満足間違いなし！',
  },
  {
    id: 3,
    img: image3,
    locations: [
      {
        branch: '田町店',
        address: '〒1080014 東京都港区芝5-9-8 GEMS田町2F',
        anycarryUrl: '',
        uberUrl:
          'https://www.ubereats.com/jp/store/%E3%82%B9%E3%83%8F%E3%82%A4%E3%82%B7%E3%83%BC%E3%83%81%E3%82%AD%E3%83%B3%E3%82%A2%E3%83%B3%E3%83%88%E3%83%88%E3%83%9E%E3%83%88-%E7%94%B0%E7%94%BA%E5%BA%97-spicy-chicken-and-tomato-tamachi/7nKjNd7MVReh-6OESqrJnw?diningMode=PICKUP',
      },
    ],
    name: 'ヤンソンさんの誘惑',
    phrase: '新米姉妹のふたりごはんで話題になったスウェーデンの家庭料理',
    description:
      'ヤンソンさんの誘惑とは19世紀に実在したとされる菜食主義者のヤンソンさんがそのあまりに美味しそうな香りに耐えられず、つい口にしてしまったという伝説を持つスウェーデンの伝統料理ヤンソンス・フレステルセのことを言います。味の決め手はたっぷりと使用したアンチョビ！細切りのジャガイモと玉ねぎ、生クリームを使用した上品でクリーミーな味わいが特徴です。当店ではデリバリー用に時間がたっても冷めにくいよう揚げたジャガイモとクリームソースを使用したオリジナルヤンソンス・フレステルセに仕上げております。少しとろみのついたクリームソースを使用することにより、冷めにくく、こぼれにくいだけでなく、ジャガイモにソースがしっかりと絡みます。本物のヤンソンさんが見たら口にしてしまうどころか完食しておかわりするに違いありません。トッピングも多数用意し、より現代的で日本的にもなったヤンソンさんの誘惑をお楽しみください。',
  },
  {
    id: 4,
    img: image4,
    locations: [
      {
        branch: '田町店',
        address: '〒1080014 東京都港区芝5-9-8 GEMS田町2F',
        anycarryUrl: 'https://anycarry.jp/pokitto-tamachi/',
        uberUrl:
          'https://www.ubereats.com/jp/store/%E3%83%95%E3%83%A9%E3%82%A4%E3%82%A2%E3%83%B3%E3%81%AE%E3%83%9B%E3%82%AD%E3%83%9B%E3%82%A6%E3%83%AB-%E7%94%B0%E7%94%BA%E5%BA%97-brians-poki-bowl-tamachi/HAsC4GyzQBS3-sHdnsVVew?diningMode=PICKUP',
      },
    ],
    name: 'ブライアンのポキボウル',
    phrase: '2人に1人がリピーター！生ケールポキ',
    description:
      '組み合わせ無限大のトロントスタイルポキ！店主がトロント留学時代に通い詰めたヘルシー且つ大満足のポキボウル店を再現しました。決め手は栄養満点の生ケール！栄養価だけでなくケールのほのかな苦みがここでしか味わえない唯一無二のポキボウルに仕上がっております。',
  },
  {
    id: 5,
    img: image5,
    locations: [
      {
        branch: '田町店',
        address: '〒1080014 東京都港区芝5-9-8 GEMS田町2F',
        anycarryUrl: 'https://anycarry.jp/spicychickenandtomato-tamachi/',
        uberUrl:
          'https://www.ubereats.com/jp/store/%E3%82%B9%E3%83%8F%E3%82%A4%E3%82%B7%E3%83%BC%E3%83%81%E3%82%AD%E3%83%B3%E3%82%A2%E3%83%B3%E3%83%88%E3%83%88%E3%83%9E%E3%83%88-%E7%94%B0%E7%94%BA%E5%BA%97-spicy-chicken-and-tomato-tamachi/7nKjNd7MVReh-6OESqrJnw?diningMode=PICKUP',
      },
    ],
    name: 'スパイシーチキンアンドトマト',
    phrase: 'ヤミツキチキン＆トマト！',
    description:
      '一度食べたらヤミツキ！味濃いめのスパイシーチキンです。バター香るターメリックライスとフレッシュトマトの最強コンボをお楽しみください。',
  },
  {
    id: 6,
    img: image6,
    locations: [
      {
        branch: '田町店',
        address: '〒1080014 東京都港区芝5-9-8 GEMS田町2F',
        anycarryUrl: '',
        uberUrl:
          'https://www.ubereats.com/jp/store/%E3%81%A6%E3%82%8A%E3%82%84%E3%81%8D%E3%82%A8%E3%82%AF%E3%82%B9%E3%83%95%E3%83%AC%E3%82%B9-%E7%94%B0%E7%94%BA%E5%BA%97-teriyaki-express-tamachi/TGd0JaLSS0aUUT6oXyLKFw?diningMode=PICKUP',
      },
    ],
    name: 'てりやきエクスプレス',
    phrase: '秘伝のタレが主役！',
    description:
      '海外で大流行のTERIYAKIを逆輸入しました。従来の照り焼きのように、食材と一緒に調理するのではなくソースとしてTERIYAKIを楽しむ海外スタイルの丼ぶりです。店内で12時間以上かけて作る完全オリジナルのTERIYAKIソースは本場の味を超えた香ばしく、白米と相性抜群の絶品ソースに仕上がっています。粒の経った国産米と香ばしく焼き上げたチキンをTERIYAKIでお楽しみください。',
  },
  {
    id: 7,
    img: image7,
    locations: [
      {
        branch: '田町店',
        address: '〒1080014 東京都港区芝5-9-8 GEMS田町2F',
        anycarryUrl: 'https://anycarry.jp/curlykale-saladselect-tamachi/',
        uberUrl:
          'https://www.ubereats.com/jp/store/%E3%82%AB%E3%83%BC%E3%83%AA%E3%83%BC%E3%82%B1%E3%83%BC%E3%83%AB%E3%81%A8%E3%82%B5%E3%83%A9%E3%82%BF%E3%82%BB%E3%83%AC%E3%82%AF%E3%83%88-%E7%94%B0%E7%94%BA%E5%BA%97/OJUmoG3MTU-c6jydEO01Kw?diningMode=PICKUP',
      },
    ],
    name: 'カーリーケールとサラダセレクト',
    phrase: '継続可能な美味しい＆ヘルシーが実現！',
    description:
      'アンチエイジング効果が見込めるビタミンACE、むくみ対策に良いとされるカリウム、貧血防止の葉酸、目の疲労回復や改善に効くルテイン、食物繊維、カルシウム、etc... 全てを兼ね備えた最強の野菜ケール。 「野菜の王様」と呼ばれるにふさわしいケールを最もよいとされる生で美味しく召し上がっていただきます！ あなたに必要な栄養を摂りやすくするサラダセレクトも合わせて「継続可能な美味しい＆ヘルシー」をご堪能ください。',
  },
  {
    id: 8,
    img: image8,
    locations: [
      {
        branch: '田町店',
        address: '〒1080014 東京都港区芝5-9-8 GEMS田町2F',
        anycarryUrl: 'https://anycarry.jp/chickenboxtamachi/',
        uberUrl:
          'https://www.ubereats.com/jp/store/%E3%82%BF%E3%83%BC%E3%83%A1%E3%83%AA%E3%83%83%E3%82%AF%E3%83%A9%E3%82%A4%E3%82%B9%E3%81%A6%E9%A3%9F%E3%81%B8%E3%82%8B!!%E3%82%BF%E3%83%B3%E3%83%88%E3%83%AA%E3%83%BC%E3%83%81%E3%82%AD%E3%83%B3box-%E7%94%B0%E7%94%BA%E5%BA%97-tandoori-chichen-with-turmeric-rice-tamachi/7ocbWD2cQwGw44agOGae6w?diningMode=PICKUP',
      },
    ],
    name: 'ターメリックライスで食べる‼タンドリーチキンBOX',
    phrase: '店内仕込み！一晩寝かせた絶品タンドリー！',
    description:
      'スパイスをたっぷり使った自家製付けダレに一晩漬けこんだ当店オリジナルのタンドリーチキン専門店です。ヘルシーで発汗作用も見込めるスパイスを使いつつジャンキーな味に仕上げました。こんがりと焼きあがったチキンはカレー風味の香ばしい香りが食欲を引き立てます。全メニューについてるフレッシュトマトがさっぱリと程よい酸味で無限ループを生み出しています。一度食べたらヤミツキ間違い無しのタンドリーチキンをお楽しみください。',
  },
  {
    id: 9,
    img: image9,
    locations: [
      {
        branch: '田町店',
        address: '〒1080014 東京都港区芝5-9-8 GEMS田町2F',
        anycarryUrl: '',
        uberUrl:
          'https://www.ubereats.com/jp/store/%E5%92%8C%E7%89%9B%E3%83%9B%E3%83%AD%E3%83%8D%E3%83%BC%E3%82%BB-ristorante-di-ragu-%E7%94%B0%E7%94%BA%E5%BA%97/eewLuIJ1XwOQUoRc7fD0Ww?diningMode=PICKUP',
      },
    ],
    name: '和牛ボロネーゼ Ristorante di ragù',
    phrase: '和牛がイタリアンを進化させました！',
    description:
      'イタリア北部のボローニャ地方のラグー・アッラ・ボロニェーゼを和牛を使って忠実に再現しました。和牛と赤ワイン、たっぷりの野菜でじっくりと時間をかけて作り上げた最高品質のボロネーゼです。素材の味をしっかり感じてもらえるよう、あえて薄味に仕上げ、通常よりたっぷりと使用しております。和牛だからこそ出せる濃い肉の味、じっくり時間をかけて出る赤ワインの渋味と甘み、たっぷりの野菜の旨味、当店でしか味わえないボロネーゼをご賞味ください。パスタはもちろん、ライスやバケットとの相性も抜群です。',
  },
  {
    id: 10,
    img: image10,
    locations: [
      {
        branch: '田町店',
        address: '〒1080014 東京都港区芝5-9-8 GEMS田町2F',
        anycarryUrl: 'https://anycarry.jp/checkenoverricetamachi/',
        uberUrl:
          'https://www.ubereats.com/jp/store/%E3%83%81%E3%82%AD%E3%83%B3%E3%82%AA%E3%83%BC%E3%83%8F%E3%83%BC%E3%83%A9%E3%82%A4%E3%82%B9%E3%83%BB%E3%82%AA%E3%83%95%E3%83%BB%E3%82%A2%E3%83%AB%E3%83%86%E3%82%A3%E3%83%A1%E3%83%83%E3%83%88-%E7%94%B0%E7%94%BA%E5%BA%97-chicken-over-rice-of-ultimate-tamachi/e2Rb59rNRvSGXQavXZfidA?diningMode=PICKUP',
      },
    ],
    name: 'チキンオーバーライス・オブ・アルティメット',
    phrase: '不動の人気！選ばれ続けている理由があります。',
    description:
      'NYの屋台フードといえばコレ！ターメリックライスの上にこんがり焼き上げたチキンをのせてヨーグルトソースとチリソースをかけて召し上がっていただきます。スパイスにこだわり10種類以上のオリジナルブレンドスパイスと特製のタレにじっくり一晩漬け込んだ究極のスパイスチキンを使用しています。オーバーライス戦国時代を生き抜いた圧倒的な美味しさを誇る究極のチキンオーバーライス「チキンオーバーライス・オブ・アルティメット」ご堪能ください。',
  },
  {
    id: 11,
    img: image11,
    locations: [
      {
        branch: '田町店',
        address: '〒1080014 東京都港区芝5-9-8 GEMS田町2F',
        anycarryUrl: 'https://anycarry.jp/jerkchickentamachi/',
        uberUrl:
          'https://www.ubereats.com/jp/store/%E7%99%BD%E7%B1%B3%E3%81%A6%E9%A3%9F%E3%81%B8%E3%82%8B!!%E3%82%B7%E3%83%A3%E3%83%BC%E3%82%AF%E3%83%81%E3%82%AD%E3%83%B3box-%E7%94%B0%E7%94%BA%E5%BA%97-jerk-chiken-box-tamachi/VIfGxTAWSXionkhNOIJDhw?diningMode=PICKUP',
      },
    ],
    name: '白米で食べる‼ジャークチキンBOX',
    phrase: '白米に合うジャークチキン！！',
    description:
      '10種類以上のスパイスと調味料にじっくり漬け込んだ特製のジャークチキン。白米に合うようちょっとだけ和のテイストを織り交ぜた当店完全オリジナルです。割合を気にするのはもちろん、スパイスによって粉末、粗びきを使い分けることで味、香りに深みを出しています。粒のたったホカホカのご飯とスパイシーな香り漂うジャークチキンの相性をご堪能ください。',
  },
  {
    id: 12,
    img: image12,
    locations: [
      {
        branch: '田町店',
        address: '〒1080014 東京都港区芝5-9-8 GEMS田町2F',
        anycarryUrl: 'https://anycarry.jp/katuratamachi/',
        uberUrl:
          'https://www.ubereats.com/jp/store/%E3%81%93%E3%81%AF%E3%82%93%E5%B0%82%E7%94%A8%E7%82%99%E3%82%8A%E7%84%BC%E8%B1%9A%E4%B8%BC-%E6%A1%82-%E7%94%B0%E7%94%BA%E5%BA%97-char-siu-bowl-katsura-tamachi/YPzq42AwQ86XUtKpUTc5qA?diningMode=PICKUP',
      },
    ],
    name: 'ご飯専用炙り焼豚丼 桂',
    phrase: 'ご飯と出会うために生まれてきました',
    description:
      'とにかくご飯に合うチャーシューを追い求めました。柔らかさ重視の特製チャーシューを大胆にカットしたチャーシュー丼専門店です。玉ねぎやニンニクをはじめとしたたっぷりの野菜と自家製ダレを合わせて野菜がとろとろに解けるまでじっくり煮込んだほろ旨チャーシューをご堪能ください。',
  },
];
